const ROW_HEIGHT = {
    small: "32px",
    medium: "40px",
    large: "48px",
    xlarge: "64px",
};
export default function table({ variables }) {
    return {
        MuiTable: {
            defaultProps: {
                size: "small",
            },
            styleOverrides: {
                root: {
                    tableLayout: "fixed",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    overflowWrap: "break-word",
                    verticalAlign: "middle",
                    fontSize: variables.type_body_font_size,
                    lineHeight: variables.type_body_sm_line_height,
                    borderBottom: `1px solid ${variables.border_subtle}`,
                },
                sizeSmall: {
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                    height: ROW_HEIGHT.small,
                    "&:where(:first-of-type)": {
                        paddingLeft: variables.spacing_06,
                    },
                    "&:where(:last-of-type)": {
                        paddingRight: variables.spacing_06,
                    },
                },
                sizeMedium: {
                    padding: `${variables.spacing_03} ${variables.spacing_03}`,
                    height: ROW_HEIGHT.medium,
                    "&:where(:first-of-type)": {
                        paddingLeft: variables.spacing_06,
                    },
                    "&:where(:last-of-type)": {
                        paddingRight: variables.spacing_06,
                    },
                },
                sizeLarge: {
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                    height: ROW_HEIGHT.large,
                    "&:where(:first-of-type)": {
                        paddingLeft: variables.spacing_06,
                    },
                    "&:where(:last-of-type)": {
                        paddingRight: variables.spacing_06,
                    },
                },
                sizeXlarge: {
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                    height: ROW_HEIGHT.xlarge,
                    "&:where(:first-of-type)": {
                        paddingLeft: variables.spacing_06,
                    },
                    "&:where(:last-of-type)": {
                        paddingRight: variables.spacing_06,
                    },
                },
                head: {
                    fontSize: variables.type_overline_font_size,
                    fontWeight: variables.type_overline_font_weight,
                    letterSpacing: variables.type_overline_letter_spacing,
                    textTransform: "uppercase",
                    lineHeight: "normal",
                    color: variables.text_medium,
                    "&&": {
                        height: "auto",
                        padding: variables.spacing_03,
                        "&:where(:first-of-type)": {
                            paddingLeft: variables.spacing_06,
                        },
                        "&:where(:last-of-type)": {
                            paddingRight: variables.spacing_06,
                        },
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                head: {
                    "&:first-of-type[class*='tableInfoHeadRow']": {
                        borderTop: "none",
                    },
                    "&.MuiTableRow-head:first-of-type": {
                        backgroundColor: variables.surface_band,
                        "& > th": {
                            color: variables.text_medium,
                        },
                    },
                    "&.MuiTableRow-head:last-child": {
                        backgroundColor: variables.surface_band,
                    },
                    "&:only-child": {
                        backgroundColor: variables.surface_band,
                    },
                },
                root: {
                    backgroundColor: variables.surface,
                    "&:nth-of-type(even):not(.MuiTableRow-head)": {
                        backgroundColor: variables.surface_subtle,
                    },
                    "&.MuiTableRow-root": {
                        "&:hover": {
                            backgroundColor: variables.surface_hover,
                        },
                    },
                    "&.Mui-selected": {
                        backgroundColor: variables.surface_selected,
                        "&:hover": {
                            backgroundColor: variables.surface_selected_hover,
                        },
                    },
                },
            },
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    flexDirection: "row",
                    fontSize: "inherit",
                    color: variables.interactive_text,
                    padding: `${variables.spacing_01} ${variables.spacing_02}`,
                    margin: `calc(-1 * ${variables.spacing_01}) calc(-1 * ${variables.spacing_02})`,
                    borderRadius: variables.border_radius_small,
                    "&:hover": {
                        backgroundColor: variables.surface_selected,
                        color: variables.interactive_hover,
                    },
                    "&.Mui-active": {
                        color: variables.interactive_selected,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=table.js.map